import type { LocationQueryValue, RouteLocationRaw } from 'vue-router'

const UNSAFE_RETURN_PREFIXES = ['/detail/', '/play/']

export function safeReturnPath(value: LocationQueryValue | LocationQueryValue[] | undefined, fallback = '/'): string {
    const candidate = Array.isArray(value) ? value[0] : value
    if (!candidate || !candidate.startsWith('/') || candidate.startsWith('//')) { return fallback }
    if (UNSAFE_RETURN_PREFIXES.some(prefix => candidate.startsWith(prefix))) { return fallback }
    return candidate
}

export function safeAuthReturnPath(value: LocationQueryValue | LocationQueryValue[] | undefined, fallback = '/'): string {
    const candidate = Array.isArray(value) ? value[0] : value
    if (!candidate || !candidate.startsWith('/') || candidate.startsWith('//') || candidate.startsWith('/login')) { return fallback }
    return candidate
}

export function detailLocation(media: { sourceId: string, id: string }, from: string): RouteLocationRaw {
    return {
        name: 'detail',
        params: { source: media.sourceId, id: media.id },
        query: { from: safeReturnPath(from) },
    }
}

export function playbackLocation(media: { sourceId: string, id: string }, episodeIndex: number | undefined, from: string): RouteLocationRaw {
    const normalizedEpisode = typeof episodeIndex === 'number' && Number.isFinite(episodeIndex)
        ? Math.max(0, Math.floor(episodeIndex))
        : 0
    return {
        name: 'play',
        params: {
            source: media.sourceId,
            id: media.id,
            episode: normalizedEpisode,
        },
        query: { from: safeReturnPath(from) },
    }
}
